import { render, staticRenderFns } from "./ByCustomers.vue?vue&type=template&id=088170b4&"
import script from "./ByCustomers.vue?vue&type=script&lang=js&"
export * from "./ByCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports